import { Text } from '@chakra-ui/react';

export default function SectionTitle({ title }: { title: string }) {
  return (
    <Text
      fontSize="2xl"
      fontFamily="uniwars"
      fontWeight="semibold"
      color="brand.500"
      pb="2"
      textAlign="center"
      zIndex="999"
    >
      {title}
    </Text>
  );
}
